"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionsModule = void 0;
const common_1 = require("../../../common");
class ActionsModule extends common_1.APIModule {
    constructor(client) {
        super(client, '/actions');
    }
    createAction(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = this.buildEndpoint([]);
            const response = yield this.client.post(endpoint, payload);
            return response.data;
        });
    }
    updateAction(actionId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = this.buildEndpoint([actionId]);
            const response = yield this.client.put(endpoint, payload);
            return response.data;
        });
    }
    deleteAction(actionId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = this.buildEndpoint([actionId]);
            const response = yield this.client.delete(endpoint);
            return response.data;
        });
    }
}
exports.ActionsModule = ActionsModule;
